import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TaxTariffTrancheHistory from './tax-tariff-tranche-history';
import TaxTariffTrancheHistoryDetail from './tax-tariff-tranche-history-detail';
import TaxTariffTrancheHistoryUpdate from './tax-tariff-tranche-history-update';
import TaxTariffTrancheHistoryDeleteDialog from './tax-tariff-tranche-history-delete-dialog';

const TaxTariffTrancheHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TaxTariffTrancheHistory />} />
    <Route path="new" element={<TaxTariffTrancheHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<TaxTariffTrancheHistoryDetail />} />
      <Route path="edit" element={<TaxTariffTrancheHistoryUpdate />} />
      <Route path="delete" element={<TaxTariffTrancheHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TaxTariffTrancheHistoryRoutes;
